module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/search-input/search-input.component.scss
// module id = ./src/app/shared-components/search-input/search-input.component.scss
// module chunks = main